var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"primary","size":"lg","disabled":_vm.disabled || _vm.loading},on:{"click":() => {_vm.$emit('click')}}},[(_vm.loading)?[_vm._v(" "+_vm._s(_vm.loadingCaption)+" ")]:[_vm._v(" "+_vm._s(_vm.caption)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }